import ApiService from "../../core/service/ApiService";
import {useEffect, useRef, useState} from "react";
import {Button, Collapse, Form, Input, Select, Typography} from "antd";
import { t } from 'i18next';
import moment from "moment";

export default function PosCancel({appointmentId, payment, posId, onSuccess}) {
    const formRef = useRef()
    const [error, setError] = useState(null)

    const onSubmit = async (values) => {
        setError(null)
        const posDevices = (await ApiService.Payment.GetPosDevices(appointmentId))?.data
        const pos = posDevices.find(device => device.id === payment.posId)

        const formData = formRef.current.getFieldsValue()
        const res = await ApiService.Payment.PavoCancelBody(payment?.id, formData.orderNo)

        if (res.success) {
            const cancel = JSON.parse(res.data)
            const posRes = await fetch(`${pos?.address}/CancelSale`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: res.data
            })

            if(posRes.ok) {
                const posData = await posRes.json()
                if (posData?.HasError) {
                    setError(`${posData?.ErrorCode}: ${posData?.Message}`)
                    return
                }

                const savePosRes = await ApiService.Payment.PavoCancel(payment?.id)
                if(savePosRes.success && !posData?.HasError) {
                    onSuccess && onSuccess()
                }
            }
            else {
                setError(t('POS device is not reachable!') + ` (${posRes.status})`)
            }
        }
    }

    return (
        <div>
            <Form
                ref={formRef}
                onFinish={onSubmit}
                layout={'vertical'}
                size={'small'}
            >
                <Form.Item
                    name={'orderNo'}
                    label={t("Order No")}
                    rules={[{required: true, message: t('Please input your order number!')}]}>
                    <Input />
                </Form.Item>

                <br/>
                <Form.Item>
                    <Button type="primary" htmlType={'submit'}>
                        {t('Cancel') + ' (' + payment?.amount + ' ₺)'}
                    </Button>
                </Form.Item>
                {
                    error && (
                        <Typography.Text style={{color: 'red', fontWeight: 'bold'}}>
                            {error}
                        </Typography.Text>
                    )
                }
            </Form>
        </div>
    )
}